"use client";

import { GradientText } from "@/components/ui/gradient-text";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does LeakNoti find unreleased music?",
    answer: "We monitor multiple verified sources and private communities 24/7 using advanced algorithms to detect new leaks instantly. Our system verifies the authenticity and quality of each track before sending notifications."
  },
  {
    question: "Is LeakNoti legal to use?",
    answer: "LeakNoti is a notification service that alerts you when content becomes available. We don't host or distribute any music files. We simply keep you informed about what's circulating in the community."
  },
  {
    question: "How fast are the notifications?",
    answer: "Our notification system typically alerts users within 60 seconds of a new leak being verified. Premium users receive priority notifications even faster."
  },
  {
    question: "Can I track any artist?",
    answer: "Yes! While we specialize in hip-hop artists, our platform tracks leaks from artists across all genres. The effectiveness may vary depending on the artist's underground presence."
  },
  {
    question: "What happens if I exceed my artist limit?",
    answer: "You'll need to untrack an artist before adding a new one, or upgrade your plan to track more artists simultaneously. Your notification history remains saved."
  }
];

export function FaqSection() {
  return (
    <section className="py-16 px-4" id="faq">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            <GradientText>Frequently Asked Questions</GradientText>
          </h2>
          <p className="text-xl text-muted-foreground">
            Everything you need to know about LeakNoti
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-lg px-4">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground px-4">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}